import GlobalContext, {
  GlobalConsumer,
  GlobalProvider,
  IGlobalContext,
} from "@/contexts/GlobalContext";
import OpinionContext, {
  OpinionConsumer,
  OpinionProvider,
  OpinionProviderProps,
  OpinionProviderState,
  StoredOpinion,
} from "@/contexts/OpinionContext";
import PollContext, {
  getPollOptionVotesPercent,
  getPollSympathizersCount,
  getPollTotalVotes,
  getPollVotesCount,
  PollConsumer,
  PollProvider,
  PollProviderProps,
  PollProviderState,
} from "@/contexts/PollContext";
import QuizContext, {
  QuizConsumer,
  QuizProvider,
  QuizProviderProps,
  QuizProviderState,
} from "@/contexts/QuizContext";
import VotingContext, {
  VotingConsumer,
  VotingContextProps,
  VotingProvider,
} from "@/contexts/VotingContext";

export {
  getPollOptionVotesPercent,
  getPollSympathizersCount,
  getPollTotalVotes,
  getPollVotesCount,
  GlobalConsumer,
  GlobalContext,
  GlobalProvider,
  IGlobalContext,
  OpinionConsumer,
  OpinionContext,
  OpinionProvider,
  OpinionProviderProps,
  OpinionProviderState,
  PollConsumer,
  PollContext,
  PollProvider,
  PollProviderProps,
  PollProviderState,
  QuizConsumer,
  QuizContext,
  QuizProvider,
  QuizProviderProps,
  QuizProviderState,
  StoredOpinion,
  VotingConsumer,
  VotingContext,
  VotingContextProps,
  VotingProvider,
};
